var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmvcPkgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_812_722)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "black",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 13.625V17.375H19.875V13.625H16.125ZM14.25 13.625C14.25 12.6094 15.0703 11.75 16.125 11.75H19.875C20.8906 11.75 21.75 12.6094 21.75 13.625V17.375C21.75 18.4297 20.8906 19.25 19.875 19.25H16.125C15.0703 19.25 14.25 18.4297 14.25 17.375V13.625ZM16.125 23.625V27.375H19.875V23.625H16.125ZM14.25 23.625C14.25 22.6094 15.0703 21.75 16.125 21.75H19.875C20.8906 21.75 21.75 22.6094 21.75 23.625V27.375C21.75 28.4297 20.8906 29.25 19.875 29.25H16.125C15.0703 29.25 14.25 28.4297 14.25 27.375V23.625ZM29.875 13.625H26.125V17.375H29.875V13.625ZM26.125 11.75H29.875C30.8906 11.75 31.75 12.6094 31.75 13.625V17.375C31.75 18.4297 30.8906 19.25 29.875 19.25H26.125C25.0703 19.25 24.25 18.4297 24.25 17.375V13.625C24.25 12.6094 25.0703 11.75 26.125 11.75ZM26.125 23.625V27.375H29.875V23.625H26.125ZM24.25 23.625C24.25 22.6094 25.0703 21.75 26.125 21.75H29.875C30.8906 21.75 31.75 22.6094 31.75 23.625V27.375C31.75 28.4297 30.8906 29.25 29.875 29.25H26.125C25.0703 29.25 24.25 28.4297 24.25 27.375V23.625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_812_722",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0156863 0 0 0 0 0.0823529 0 0 0 0 0.12549 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_812_722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_812_722",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmvcPkgIcon);
export default __webpack_public_path__ + "static/media/tmvc-pkg-icon.d97c87e9e25aa96f6470f5312f829a65.svg";
export { ForwardRef as ReactComponent };